import layout from '@/layout'

export default {
  path: '/winner',
  component: layout,
  redirect: '/winner/cal_open',
  name: 'winner_cal_open',
  meta: {
    title: 'winner',
    icon: 'winner'
  },
  children: [
    {
      path: '/winner/cal_open',
      name: 'winner_cal_open',
      component: () => import('@/views/winner/pages/cal_open/index.vue'),
      meta: {
        title: 'winner_cal_open',
        icon: 'cal'
      }
    }
  ]
}
